import { useState, useEffect, forwardRef } from 'react';
import { useFilterStore } from '../../store/useFilterStore.js';

export const SearchBar = forwardRef(function SearchBar(_, ref) {
  const setSearch = useFilterStore((s) => s.setSearch);
  const [input, setInput] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => setSearch(input), 300);
    return () => clearTimeout(timer);
  }, [input, setSearch]);

  return (
    <input
      ref={ref}
      type="text"
      value={input}
      onChange={(e) => setInput(e.target.value)}
      placeholder="Search company, role, notes…"
      className="w-full max-w-xs rounded border border-slate-300 px-3 py-1.5 text-base focus:outline-none focus:ring-1 focus:ring-primary-500"
    />
  );
});
